import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { rem } from '@bonusly/design-system';

import { Panel } from '../../../components/panel';
import { RewardsHighlightsContent } from '../../../components/rewards/highlights/rewards-highlights-content';

interface RewardsHighlightsPanelProps {
	isOpen: boolean;
	isSidebarExpanded: boolean;
	onClose: () => void;
}

export const RewardsHighlightsPanel: FC<RewardsHighlightsPanelProps> = ({ isOpen, isSidebarExpanded, onClose }) => {
	const { t } = useTranslation('navigation');
	const navigate = useNavigate();

	const handleShopAllClick = () => {
		onClose();
		navigate('/rewards');
	};

	return (
		<Panel
			isOpen={isOpen}
			onClose={onClose}
			isSidebarExpanded={isSidebarExpanded}
			title={t('rewardsPanel.title')}
			closeButtonLabel={t('rewardsPanel.close')}
			width={rem(400)}
			data-testid="rewards-highlights-panel"
		>
			<RewardsHighlightsContent onShopAllClick={handleShopAllClick} />
		</Panel>
	);
};
